import React from 'react';
import Icon from '../../../components/AppIcon';

const ThreatMonitor = ({ threats }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-error text-error-foreground';
      case 'high':
        return 'bg-warning text-warning-foreground';
      case 'medium':
        return 'bg-accent text-accent-foreground';
      case 'low':
        return 'bg-success text-success-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return 'AlertCircle';
      case 'monitoring':
        return 'Eye';
      case 'resolved':
        return 'CheckCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Active Threats</h3>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-error rounded-full pulse-urgent"></div>
          <span className="text-sm text-gray-600 dark:text-gray-300">{threats?.filter(t => t?.status === 'active')?.length} Active</span>
        </div>
      </div>
      <div className="space-y-4">
        {threats?.map((threat) => (
          <div key={threat?.id} className="border border-border rounded-lg p-4 animation-organic hover:border-primary/50">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <Icon name={getStatusIcon(threat?.status)} size={20} color="var(--color-warning)" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4 mb-2">
                  <h4 className="font-medium text-gray-900 dark:text-white">{threat?.type}</h4>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${getSeverityColor(threat?.severity)}`}>
                    {threat?.severity?.toUpperCase()}
                  </span>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">{threat?.location}</p>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">{threat?.description}</p>
                <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
                  <div className="flex items-center gap-1">
                    <Icon name="Clock" size={14} color="currentColor" />
                    <span>{threat?.detectedAt}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="User" size={14} color="currentColor" />
                    <span>{threat?.assignedTo}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThreatMonitor;